<template>
  <work-order-card>
    <h3 slot="card-header">提交工单</h3>
    <div slot="card-body">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form
            :model="form"
            :rules="rules"
            label-width="125px"
            ref="workOrder"
          >
            <el-form-item label="工单分类" prop="parentQaTypeId">
              <el-select
                v-model="form.parentQaTypeId"
                @change="getQaTypeOptions"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in parentQaTypeOptions"
                  :key="item.parentTypeId"
                  :value="item.parentTypeId"
                  :label="item.parentQaTypeName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工单类型" prop="qaTypeId">
              <el-select
                v-model="form.qaTypeId"
                style="width: 100%"
                :disabled="!form.parentQaTypeId"
                @change="onQaTypeIdChange"
                filterable
              >
                <el-option
                  v-for="item in qaTypeOptions"
                  :key="item.qaTypeId"
                  :label="item.qaTypeName"
                  :value="item.qaTypeId"
                >
                  <span style="float: left">{{ item.qaTypeName }}</span>
                  <span v-if="item.qaTypeDesc" style="float: right">
                    <el-tooltip :content="item.qaTypeDesc">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>

            <FormSeal v-if="this.currentHandlerType === 'SEAL_QUALIFICATION'" />
            <FormAccount
              v-else-if="this.currentHandlerType === 'ACCOUNT_CREATION'"
            />
            <FormNormalModules v-else />

            <el-form-item>
              <el-button
                type="primary"
                :disabled="submitDisabled"
                @click="submitForm"
                :loading="loading"
                >提交
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-card v-if="form.qaTypeId" style="margin-right: 20px">
            <template v-if="this.currentHandlerType === 'SEAL_QUALIFICATION'">
              <p>
                <i class="el-icon-s-custom"></i> 承接人：
                <span v-if="sealHrError" class="seal-error-text">{{
                  sealHrError
                }}</span>
                <span
                  v-else-if="sealWorkLocationHr && sealWorkLocationHr.realName"
                >
                  {{ sealWorkLocationHr.realName
                  }}<span v-if="sealWorkLocationHr.deptName">
                    （{{ sealWorkLocationHr.deptName }}）</span
                  >
                </span>
                <span v-else>-</span>
              </p>
              <p>
                <i class="el-icon-user-solid"></i> 内置关注人：<span>-</span>
              </p>
              <p><i class="el-icon-s-check"></i> 审批流程预览：</p>
              <div style="max-height: 360px; max-width: 340px; overflow: auto">
                <el-timeline>
                  <el-timeline-item
                    v-for="(node, idx) in sealApprovalPreviewNodes"
                    :key="idx"
                  >
                    <span>{{ node.title }}</span>
                    <br />
                    <span style="color: #909399; font-size: 13px">{{
                      node.sub
                    }}</span>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </template>
            <template
              v-else-if="this.currentHandlerType === 'ACCOUNT_CREATION'"
            >
              <p>
                <i class="el-icon-s-custom"></i> 承接人：<span>{{
                  acctSoftwareAcceptorsLine || "-"
                }}</span>
              </p>
              <p>
                <i class="el-icon-user-solid"></i> 内置关注人：<span>-</span>
              </p>
              <p><i class="el-icon-s-check"></i> 审批流程预览：</p>
              <div style="max-height: 360px; max-width: 340px; overflow: auto">
                <el-timeline>
                  <el-timeline-item
                    v-for="(node, idx) in acctApprovalPreviewNodes"
                    :key="'acct-ap-' + idx"
                  >
                    <span>{{ node.title }}</span>
                    <br />
                    <span style="color: #909399; font-size: 13px">{{
                      node.sub
                    }}</span>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </template>
            <template v-else>
              <p>
                <i class="el-icon-s-custom"></i> 承接人：
                <!-- 固定承接人 -->
                <template v-if="acceptorMode == 'SPECIFIC'">
                  <template v-if="allowSpecifyAcceptor">
                    <work-order-user-select-v2
                      :multipleLimit="1"
                      v-model="form.considerPeoples"
                      :allOptions="acceptorUserOptions"
                    ></work-order-user-select-v2>
                    <span>当前工单支持指定承接人</span>
                  </template>
                  <template v-else>
                    <template
                      v-if="
                        form.considerPeoples && form.considerPeoples.length > 0
                      "
                    >
                      <span
                        v-for="(item, index) in form.considerPeoples"
                        :key="index"
                      >
                        {{ item.userName }}
                      </span>
                    </template>
                    <span v-else> -</span>
                  </template>
                </template>
                <!-- 动态承接人 -->
                <template v-else>
                  <span>
                    {{ convertDynamicAcceptor(acceptorMode) || "-" }}</span
                  >
                </template>

                <!-- <template
                v-if="form.considerPeoples && form.considerPeoples.length > 0"
              >
                <span
                  v-for="(item, index) in form.considerPeoples"
                  :key="index"
                >
                  {{ item.userName }}
                </span>
              </template>
              <span v-else> -</span> -->
              </p>
              <p>
                <i class="el-icon-user-solid"></i> 内置关注人：
                <template
                  v-if="
                    form.builtIntoFollowPeoples &&
                    form.builtIntoFollowPeoples.length > 0
                  "
                >
                  <span
                    v-for="(item, index) in form.builtIntoFollowPeoples"
                    :key="index"
                  >
                    {{ item.userName }}
                  </span>
                </template>
                <span v-else> -</span>
              </p>
              <template
                v-if="
                  form.midConsiderPeoples && form.midConsiderPeoples.length > 0
                "
              >
                <p><i class="el-icon-s-check"></i> 审批流程预览：</p>
                <div
                  style="max-height: 300px; max-width: 300px; overflow: auto"
                >
                  <el-timeline>
                    <el-timeline-item
                      v-for="(item, index) in form.midConsiderPeoples"
                      :key="index"
                    >
                      <!-- 节点名称 -->
                      <span> {{ item.name }}</span> <br />
                      <!-- 节点类型 -->
                      <span
                        style="color: #909399; line-height: 1; font-size: 13px"
                      >
                        {{ MidConsiderTypeEnum[item.type] }}</span
                      >
                      <!-- 具体审批人 -->
                      <span
                        v-if="item.peoples && item.peoples.length > 0"
                        style="color: #909399; line-height: 1; font-size: 13px"
                      >
                        - {{ item.peoples[0].userName }}
                      </span>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </template>
            </template>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </work-order-card>
</template>

<script>
import api from "plus/api";
import { getAllUserOptions } from "@/components/workOrderUserSelectV2/userOptionsService.js";
import FormSeal from "./components/FormSeal.vue";
import FormAccount from "./components/FormAccount.vue";
import FormNormalModules from "./components/FormNormalModules.vue";
import {
  MID_CONSIDER_TYPE_ENUM,
  WORK_ORDER_PROP_RULE_ENUM,
  WORK_ORDER_TEMPLATE_ENUM,
} from "./config";
import sealMixin from "./mixins/sealMixin";
import accountMixin from "./mixins/accountMixin";
import normalModulesMixin from "./mixins/normalModulesMixin";

export default {
  name: "work.submit.write",
  components: {
    FormSeal,
    FormAccount,
    FormNormalModules,
  },
  mixins: [normalModulesMixin, sealMixin, accountMixin],
  provide() {
    return {
      workSubmit: this,
    };
  },
  data() {
    return {
      loading: false,
      form: {
        attachments: [],
        customerInfoList: [],
        followPeoples: [],
        priority: "NORMAL",
        tagCustomer: "",
        tagRadio: "",
        labelName: [],
        qaTypeId: "",
        parentQaTypeId: "",
        relationWorkOrderIds: [""],
        remark: "",
        webInfo: {
          websiteName: "",
          websiteUrl: "",
        },
        doctorInfo: {
          doctorName: "",
          practiceCertificate: "",
        },
        companyInfo: {
          companyInfo: "",
        },
        money: void 0,
        wkOrderTopic: "",
        midConsiderPeoples: [],
        newFollowPeoples: [],
        builtIntoFollowPeoples: [],
        needNotifyFollowPeople: false,
        notifyBuiltIntoFollowPeoples: false,
        considerPeoples: [],
        accurateCustomerInfo: {
          customerId: "",
          customerPhone: "",
        },
        accurateCompanyInfo: {
          abbreviation: "",
          companyId: "",
          companyName: "",
        },
        accurateProjectInfo: [],
        businessType: null,
      },
      regionalSelectValue: "",
      accurateCompanyInfoSelectValue: "",
      accurateProjectInfoSelectValue: "",
      companyLoading: false,
      acceptorMode: "",
      allowSpecifyAcceptor: false,
      rules: {
        parentQaTypeId: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        qaTypeId: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
      },
      parentQaTypeOptions: [],
      qaTypeOptions: [],
      qaTypeTemplateOptions: [],
      qaTypePrompt: "",
      propRuleEnum: WORK_ORDER_PROP_RULE_ENUM,
      enableEditAttentionUser: true,
      templateEnum: WORK_ORDER_TEMPLATE_ENUM,
      relationWorkOrderOptions: [],
      tagList: [
        { label: "1", name: "wangqin1" },
        { label: "2", name: "wangqin2" },
      ],
      custList: [
        { label: "3", name: "大幅度" },
        { label: "4", name: "大幅度2" },
      ],
      tagOptions: [],
      checkSig: [],
      checkMore: [],
      allUserOptions: [],
      MidConsiderTypeEnum: MID_CONSIDER_TYPE_ENUM,
      areaTree: [],
      projectTree: [],
      projectLoading: false,
      companyList: [],
      acceptorUserOptions: [],
      uploadLoading: false,
      currentHandlerType: "NORMAL",
    };
  },
  computed: {
    submitDisabled() {
      if (!this.form.parentQaTypeId || !this.form.qaTypeId) return true;
      if (this.currentHandlerType === "SEAL_QUALIFICATION") {
        if (!this.sealApplicantUsers.length) return true;
        if (this.sealArchiveLoading) return true;
        if (!this.sealHrReady) return true;
      } else if (this.currentHandlerType === "ACCOUNT_CREATION") {
        if (!this.acctEmployeeUsers.length) return true;
        if (this.acctEmployeeArchiveLoading) return true;
      }
      return false;
    },
  },
  created() {
    this.getParentQaTypeOptions();
    this.init();
  },
  activated() {
    if (this.$route.query.id) {
      this.getWorkOrderShow();
    }
  },
  deactivated() {
    this.form = this.$options.data().form;
    this.$refs["workOrder"].resetFields();
    this.qaTypeTemplateOptions = [];
    this.resetSealQualificationState();
    this.resetAccountCreationState();
    this.currentHandlerType = "NORMAL";
  },
  methods: {
    async init() {
      this.getCompanyList();
      this.getAreaTree();
      this.allUserOptions = await getAllUserOptions();
    },
    async getParentQaTypeOptions() {
      const response = await api.dropDownList.getWorkCutNew();
      this.parentQaTypeOptions = response.data.data;
    },
    async getQaTypeOptions(val) {
      this.form.qaTypeId = "";
      this.qaTypeTemplateOptions = [];
      this.currentHandlerType = "";
      this.restFormFields();
      this.resetSealQualificationState();
      this.resetAccountCreationState();
      const response = await api.dropDownList.getWorkTypeNew({
        id: val,
      });
      this.qaTypeOptions = response.data.data;
    },
    restFormFields() {
      this.form.midConsiderPeoples = [];
      this.form.attachments = [];
      this.form.customerInfoList = [];
      this.form.newFollowPeoples = [];
      this.form.relationWorkOrderIds = [""];
      this.form.remark = "";
      this.form.webInfo = {
        websiteName: "",
        websiteUrl: "",
      };
      this.form.doctorInfo = {
        doctorName: "",
        practiceCertificate: "",
      };
      this.form.accurateProjectInfo = [];
      this.accurateProjectInfoSelectValue = "";
      this.form.wkOrderTopic = "";
    },
    async onQaTypeIdChange(val) {
      // 1. 空值直接返回
      if (!val) {
        return;
      }

      // 2. 获取配置与处理类型
      const opt = this.qaTypeOptions.find((x) => x.qaTypeId === val);
      const handlerType = (opt && opt.handlerType) || "NORMAL";

      // 3. 校验：不支持的 handlerType 直接拦截
      const validHandlerTypes = [
        "NORMAL",
        "SEAL_QUALIFICATION",
        "ACCOUNT_CREATION",
      ];
      if (!validHandlerTypes.includes(handlerType)) {
        this.$message.warning("该工单类型暂不支持在此页面提交");
        this.$nextTick(() => {
          this.form.qaTypeId = "";
          this.currentHandlerType = "NORMAL";
        });
        return;
      }

      // 4. 赋值当前处理类型
      this.currentHandlerType = handlerType;

      // 5. 重置字段
      this.resetSpecialTypeCommonFields();

      // 6. 根据类型分发到对应处理逻辑
      switch (handlerType) {
        case "NORMAL":
          await this.handleQaTypeNormal(val);
          break;
        case "SEAL_QUALIFICATION":
          await this.handleQaTypeSealQualification(opt);
          break;
        case "ACCOUNT_CREATION":
          await this.handleQaTypeAccountCreation(opt);
          break;
      }
    },

    /**
     * 处理 NORMAL 普通工单类型切换
     */
    async handleQaTypeNormal(val) {
      await this.getQaTypeTemplateOptions(val);
    },

    /**
     * 处理 SEAL_QUALIFICATION 用章资质工单类型切换
     */
    async handleQaTypeSealQualification(opt) {
      this.form.wkOrderTopic = (opt && opt.qaTypeName) || "";
      this.resetSealQualificationState();
      await this.bootstrapSealQualificationForm();
    },

    /**
     * 处理 ACCOUNT_CREATION 账号创建工单类型切换
     */
    async handleQaTypeAccountCreation(opt) {
      this.form.wkOrderTopic = (opt && opt.qaTypeName) || "";
      this.resetAccountCreationState();
      await this.bootstrapAccountCreationForm();
    },

    /**
     * 抽离：特殊工单类型共用的重置字段逻辑
     */
    resetSpecialTypeCommonFields() {
      this.qaTypeTemplateOptions = [];
      this.form.midConsiderPeoples = [];
      this.form.builtIntoFollowPeoples = [];
      this.form.considerPeoples = [];
      this.acceptorMode = "";
      this.allowSpecifyAcceptor = false;
      this.restFormFields();
    },
    async getQaTypeTemplateOptions(val) {
      if (!val) {
        return;
      }
      const response = await api.dropDownList.getWorkTemplates({
        qaTypeId: val,
      });
      this.getTags(val);
      const {
        qaTypePrompt,
        templates,
        midConsiderPeoples,
        enableEditAttentionUser,
        notifyBuiltIntoFollowPeoples,
        builtIntoFollowPeoples,
        considerPeoples,
        defaultNotifySubmitFollowPeoples,
        // v4.0
        acceptorMode,
        allowSpecifyAcceptor,
      } = response.data.data;
      this.enableEditAttentionUser = enableEditAttentionUser;
      this.restFormFields();
      this.form.newFollowPeoples = [];
      this.getPreFilledWords(templates);
      if (midConsiderPeoples) {
        this.form.midConsiderPeoples = midConsiderPeoples;
      } else {
        this.form.midConsiderPeoples = [];
      }
      this.form.notifyBuiltIntoFollowPeoples = notifyBuiltIntoFollowPeoples;
      this.form.builtIntoFollowPeoples = builtIntoFollowPeoples;
      this.form.considerPeoples = considerPeoples;
      this.form.needNotifyFollowPeople = defaultNotifySubmitFollowPeoples;
      this.acceptorMode = acceptorMode;
      this.allowSpecifyAcceptor = allowSpecifyAcceptor;
      // templates.push({isRequired: false,moduleName: "COMPANY_MODEL",sortNum: 7,})
      // templates.push({isRequired: true,moduleName: "MONEY_MODEL",sortNum: 8,})
      // templates.push({isRequired: true,moduleName: "LABEL_MODEL",sortNum: 9,})

      this.qaTypeTemplateOptions = templates;
      if (
        templates.some(
          (item) => item.moduleName === "ACCURATE_PROJECT_INFO",
        )
      ) {
        this.getProjectTree();
      }
      const hasUserInfo = templates.some(
        (item) => item.moduleName === "CUSTOMER_INFO",
      );
      if (hasUserInfo) {
        this.addUserInfo();
      }
      this.qaTypePrompt = qaTypePrompt;

      this.accurateCompanyInfoSelectValue = ""; // 恢复空值
      this.regionalSelectValue = ""; // 恢复空值
      this.accurateProjectInfoSelectValue = ""; // 恢复空值
      this.getCompanyList(""); // 恢复空值

      if (
        this.form.considerPeoples &&
        this.form.considerPeoples.length > 1 &&
        acceptorMode == "SPECIFIC"
      ) {
        this.acceptorUserOptions = this.allUserOptions.filter((x) =>
          this.form.considerPeoples.some((y) => y.userId == x.userId),
        );
        if (this.allowSpecifyAcceptor) {
          this.acceptorUserOptions = [
            {
              userName: "随机",
              userId: null,
              effective: true,
              beisenUserId: -1,
            },
            ...this.acceptorUserOptions,
          ];
          this.form.considerPeoples = [this.acceptorUserOptions[0]];
        }

        // if(this.form.allowSpecifyAcceptor){
        //   this.form.considerPeoples=[this.acceptorUserOptions[0]]
        // }
      }
    },
    // 获取预填写内容
    getPreFilledWords(templates) {
      if (!templates) {
        this.form.remark = "";
        return;
      }
      let list = templates.filter((x) => x.moduleName == "WORK_ORDER_DESCRIBE");
      if (list && list.length > 0) {
        this.form.remark = list[0].preFilledWords;
      }
    },
    async getWorkOrderShow() {
      const response = await api.work.getWorkOrderShow({
        id: this.$route.query.id,
      });
      this.form = response.data.data;
      if (!this.form.webInfo) {
        this.form.webInfo = {
          websiteUrl: "",
          websiteName: "",
        };
      }
      if (!this.form.doctorInfo) {
        this.form.doctorInfo = {
          doctorName: "",
          practiceCertificate: "",
        };
      }
      if (!Array.isArray(this.form.accurateProjectInfo)) {
        this.$set(
          this.form,
          "accurateProjectInfo",
          this.form.accurateProjectInfo ? [this.form.accurateProjectInfo] : [],
        );
      }
      // 精准项目信息改为单选一级项目，回填首个项目ID
      this.accurateProjectInfoSelectValue =
        this.form.accurateProjectInfo[0] || "";
      this.qaTypeTemplateOptions = this.form.templates;
      if (
        this.qaTypeTemplateOptions.some(
          (item) => item.moduleName === "ACCURATE_PROJECT_INFO",
        )
      ) {
        this.getProjectTree();
      }
      if (!Array.isArray(this.form.attachments)) {
        this.form.attachments = [];
      }
      delete this.form.templates;
      const response1 = await api.dropDownList.getWorkTypeNew({
        id: this.form.parentQaTypeId,
      });
      this.qaTypeOptions = response1.data.data;
    },
    submitForm() {
      // 附件上传等待判断（公共逻辑）
      if (
        (this.currentHandlerType === "SEAL_QUALIFICATION" &&
          this.sealUploadLoading) ||
        (this.currentHandlerType !== "SEAL_QUALIFICATION" && this.uploadLoading)
      ) {
        this.$message.warning("请等待附件上传完成");
        return;
      }

      // 表单校验主入口
      this.$refs["workOrder"].validate(async (valid) => {
        if (!valid) return;

        // 根据类型分发到对应处理方法
        switch (this.currentHandlerType) {
          case "ACCOUNT_CREATION":
            await this.handleSubmitAccountCreation();
            break;
          case "SEAL_QUALIFICATION":
            await this.handleSubmitSealQualification();
            break;
          default:
            await this.handleSubmitNormal();
            break;
        }
      });
    },

    /**
     * 处理 账号创建 类型工单提交
     */
    async handleSubmitAccountCreation() {
      // 表单校验
      const err = this.validateAccountCreationForm();
      if (err) {
        this.$message.error(err);
        return;
      }

      // 编辑模式判断
      if (this.$route.query.id) {
        this.$message.warning("当前编辑模式不支持该工单类型");
        return;
      }

      this.loading = true;
      try {
        const opt = this.qaTypeOptions.find(
          (x) => x.qaTypeId === this.form.qaTypeId,
        );
        const body = {
          qaTypeId: this.form.qaTypeId,
          handlerType: "ACCOUNT_CREATION",
          wkOrderTopic:
            (this.form.wkOrderTopic && this.form.wkOrderTopic.trim()) ||
            (opt && opt.qaTypeName) ||
            "",
          accountCreation: this.buildAccountCreationPayload(),
          acceptorHandleRule: "COUNTERSIGN",
        };

        const response = await api.work.createWork(body);
        if (response.data.success) {
          this.$message.success("创建成功");
          this.resetCommonFormFields(); // 抽离公共重置逻辑
          this.resetAccountCreationState();
          this.currentHandlerType = "NORMAL";
        } else {
          this.$message.error(response.data.msg);
        }
      } catch (e) {
        this.$message.error("提交失败");
      } finally {
        this.loading = false;
      }
    },

    /**
     * 处理 用章资质 类型工单提交
     */
    async handleSubmitSealQualification() {
      // 表单校验
      const err = this.validateSealForm();
      if (err) {
        this.$message.error(err);
        return;
      }

      // 编辑模式判断
      if (this.$route.query.id) {
        this.$message.warning("当前编辑模式不支持该工单类型");
        return;
      }

      this.loading = true;
      try {
        const opt = this.qaTypeOptions.find(
          (x) => x.qaTypeId === this.form.qaTypeId,
        );
        const body = {
          qaTypeId: this.form.qaTypeId,
          handlerType: "SEAL_QUALIFICATION",
          wkOrderTopic:
            (this.form.wkOrderTopic && this.form.wkOrderTopic.trim()) ||
            (opt && opt.qaTypeName) ||
            "",
          sealQualification: this.buildSealQualificationPayload(),
        };

        const response = await api.work.createWork(body);
        if (response.data.success) {
          this.$message.success("创建成功");
          this.resetCommonFormFields(); // 抽离公共重置逻辑
          this.resetSealQualificationState();
          this.resetAccountCreationState();
          this.currentHandlerType = "NORMAL";
        } else {
          this.$message.error(response.data.msg);
        }
      } catch (e) {
        this.$message.error("提交失败");
      } finally {
        this.loading = false;
      }
    },

    /**
     * 处理 默认普通 类型工单提交
     */
    async handleSubmitNormal() {
      // 公共前置校验
      this.clearEmpty();
      if (this.checkRelationIdRequired() && this.checkRelationIdEmpty()) {
        this.$message.error("请填写关联工单");
        return;
      }
      if (this.checkMutiId(this.form.relationWorkOrderIds)) {
        this.$message.error("请勿提交重复关联工单");
        return;
      }

      // 承接人处理逻辑
      if (this.acceptorMode === "SPECIFIC" && this.allowSpecifyAcceptor) {
        this.form.acceptor =
          this.form.considerPeoples.length > 0 &&
          this.form.considerPeoples[0].userId !== -1
            ? this.form.considerPeoples[0]
            : null;
      } else {
        this.form.acceptor = null;
      }

      // 关注人赋值
      this.form.followPeoples = [
        ...this.form.builtIntoFollowPeoples,
        ...this.form.newFollowPeoples,
      ];
      // 精准项目信息单选一级项目，提交时只保留所选的一个项目ID
      this.form.accurateProjectInfo = this.accurateProjectInfoSelectValue
        ? [this.accurateProjectInfoSelectValue]
        : [];
      this.form.handlerType = "NORMAL";
      this.loading = true;

      try {
        if (this.$route.query.id) {
          // 编辑更新逻辑
          const response = await api.work.rejectEdit(this.form);
          if (response.data.success) {
            this.$message.success("更新成功");
            this.resetCommonFormFields();
            this.restFormFields();
            await this.$router.push({ name: "work.submit.write" });
          } else {
            this.$message.error(response.data.msg);
          }
        } else {
          // 新建工单逻辑
          if (
            this.qaTypeTemplateOptions.filter(
              (x) => x.moduleName === "DOCTOR_INFO",
            ).length === 0
          ) {
            this.form.doctorInfo = null;
          }
          const response = await api.work.createWork(this.form);
          if (response.data.success) {
            this.$message.success("创建成功");
            this.resetCommonFormFields();
          } else {
            this.$message.error(response.data.msg);
          }
        }
      } catch (e) {
        this.$message.error("提交失败");
      } finally {
        this.loading = false;
      }
    },

    /**
     * 抽离：所有类型共用的表单重置方法（减少重复代码）
     */
    resetCommonFormFields() {
      this.$refs["workOrder"].resetFields();
      this.qaTypeTemplateOptions = [];
      this.form.midConsiderPeoples = [];
      this.form.notifyBuiltIntoFollowPeoples = false;
      this.form.builtIntoFollowPeoples = [];
      this.form.newFollowPeoples = [];
      this.form.considerPeoples = [];
    },
  },
};
</script>
<style lang="less" scoped>
.ellipsis-label {
  /deep/ .el-form-item__label {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
}
.card-fixed {
  position: fixed;
  right: 100px;
}
</style>
